<template>
  <tk-container
    disableScroll
    :hideStatusBar="pathArr.includes($route.path)"
  >
    <!--用户底部切换-->
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
    <tk-flex
      around
      slot="footer"
      class="home-layout-footer"
      v-if="footerStatus"
    >
      <tk-flex column center v-for="(item, index) in menuData" :key="index" @click.native="onClick(item.path, item)" class="p-8" :class="{active: isActive(item.path)}">
        <tkui-badge :value="shoppingCartNum" v-if="shoppingCartNum > 0 && item.path === '/home/shoppingCar'">
          <tk-icon size="25">{{isActive(item.path) ? item.replaceIcon : item.icon}}</tk-icon>
        </tkui-badge>
        <tk-icon size="25" v-else>{{isActive(item.path) ? item.replaceIcon : item.icon}}</tk-icon>
        <span class="m-t-4">{{item.text}}</span>
      </tk-flex>
    </tk-flex>
  </tk-container>
</template>
<script>
export default {
  name: 'home-layout',
  data () {
    return {
      menu: [
        {
          icon: 'home',
          replaceIcon: 'home_selected',
          text: '首页',
          path: '/'
        },
        {
          icon: 'classification',
          replaceIcon: 'classification_selected',
          text: '分类',
          path: '/home/classification'
        },
        {
          icon: 'community',
          replaceIcon: 'community_selected',
          text: '社区',
          path: '/home/community'
        },
        {
          icon: 'shoppingcart',
          replaceIcon: 'shoppingcart_selected',
          text: '购物车',
          path: '/home/shoppingCar'
        }, {
          icon: 'mine',
          replaceIcon: 'mine_selected',
          text: '我的',
          path: '/home/itsMine'
        }
      ]
    }
  },
  computed: {
    pathArr () {
      return ['/', '/home/shoppingCar', '/home/itsMine']
    },
    // 加入购物车的商品数量
    shoppingCartNum () {
      if (!this.$store.state.shoppingSum) { return 0 }
      return this.$store.state.shoppingSum
    },
    // 如果为厂家账号去掉购物车
    menuData () {
      let arr = this.$tkHelper.deepClone(this.menu)
      if (this.isUpShelf) {
        arr = arr.filter(s => { return s.icon !== 'community' })
      }
      if (this.isFactoryAccount) {
        let index = arr.findIndex(s => { return s.text === '购物车' })
        arr.splice(index, 1)
        return arr
      }
      return arr
    }
  },
  methods: {
    isActive (path) {
      return this.$route.path === path
    },
    onClick (path, item) {
      this.$replace(path)
    }
  }
}
</script>
<style lang="scss" scoped>
  .home-layout-footer {
    background: #FFFFFF;
    border-top: 1px solid #f5f5f5;
    color: #212121;
    font-size: 11px;
    .active {
      color: #CF1613;
    }
    ::v-deep {
      .tkui-badge .tkui-badge-wrapper {
        top: -6px !important;
        right: -14px !important;
      }
    }
  }
</style>
